'use client';
import {type SightCategory} from '#/cms/schemas/sight-category.schema';
import type {Sight} from '#/cms/schemas/sight.schema';
import {Map, type MapProps} from '#/features/components/Map';
import {latLngToGoogleLatLngLiteral} from '#/utils/geo';
import {useMemo} from 'react';
import {SightMapMarker} from './SightMapMarker';

type Props = Pick<MapProps, 'searchRadius'> & {
  sights: Sight[];
  sightCategories: SightCategory[];
};

/**
 * Displays a map with sight markers and a search radius if provided.
 */
export const SightsMap = (props: Props) => {
  const {searchRadius, sightCategories, sights} = props;
  const mapSights = useMemo(() => sights.filter(sight => sight.showOnMap && sight.coordinate), [sights]);
  const boundsLatLngs = useMemo(
    () =>
      mapSights
        .map(sight => (sight.coordinate ? latLngToGoogleLatLngLiteral(sight.coordinate) : undefined))
        .filter((position): position is google.maps.LatLngLiteral => !!position),
    [mapSights]
  );

  return (
    <Map
      boundsLatLngs={boundsLatLngs}
      Markers={
        <>
          {mapSights.map(sight => (
            <SightMapMarker key={sight.id} sight={sight} sightCategories={sightCategories} />
          ))}
        </>
      }
      searchRadius={searchRadius}
    />
  );
};
